export const LOCATIONS = {
 "Horizon1"         : "Horizon 1",
 "Horizon2"         : "Horizon 2",
 "guillotine1"      : "Guillotine",
 "duplo1"           : "Duplo",
 "graphicwizard1"   : "Graphic Wizard",
 "tagholepuncher1"  : "Tag Hole Puncher",
 "Laser"            : "Laser"
};

export const STATIONS = [
    {station: "bin_station", label : "Bin Station", typeOf: 'orders', backgroundColor: 'rgba(191, 63, 63, .5)', borderColor:'rgba(191, 63, 63, .5)' },
    {station: "qa_station", label  : "QA Station", typeOf: 'orders', backgroundColor: 'rgba(191, 127, 63, .5)', borderColor: 'rgba(191, 127, 63, .5)' },
    {station: "shipment_station", label : "Shipment Station", typeOf: 'orders', backgroundColor: 'rgba(191, 191, 63, .5)', borderColor: 'rgba(191, 191, 63, .5)'},
    {station: "ups_station", label : "UPS Station", typeOf: 'orders', backgroundColor: 'rgba(127, 191, 63, .5)', borderColor: 'rgba(127, 191, 63, .5)'},
    {station: "Horizon1", label : "Horizon 1", typeOf: 'jobs', backgroundColor: 'rgba(51, 153, 255, .5)', borderColor: 'rgba(51, 153, 255, .5)'},
    {station: "Horizon2", label : "Horizon 2", typeOf: 'jobs', backgroundColor: 'rgba(153, 102, 255, .5)',borderColor: 'rgba(153, 102, 255, .5)'},
    {station: "guillotine1", label : "Guillotine", typeOf: 'jobs', backgroundColor: 'rgba(255, 0, 255, .5)', borderColor: 'rgba(255, 0, 255, .5)'},
    {station: "duplo1", label : "Duplo", typeOf: 'jobs', backgroundColor: 'rgba(51, 51, 204, .5)',borderColor: 'rgba(51, 51, 204, .5)'},
    {station: "graphicwizard1", label : "Graphic Wizard", typeOf: 'jobs', backgroundColor: 'rgba(0, 153, 153, .5)',borderColor: 'rgba(0, 153, 153, .5)'},
    {station: "tagholepuncher1", label  : "Tag Hole Puncher", typeOf: 'jobs', backgroundColor: 'rgba(102, 102, 153, .5)', borderColor: 'rgba(102, 102, 153, .5)'},
    {station: "Laser", label  : "Laser", typeOf: 'orders', backgroundColor: 'rgba(177, 183, 197, 0.8)', borderColor: 'rgba(177, 183, 197, 0.8)'}
];

export const STATIONMAP = {
    "bin_station" : {label : "Bin Station", type: 'order'},
    "qa_station": { label  : "QA Station", type: 'order'},
    "shipment_station": { label : "Shipment Station", type: 'order'},
    "ups_station": {label : "UPS Station", type: 'order'},
    "Horizon1": { label : "Horizon 1", type: 'job'},
    "Horizon2": { label : "Horizon 2", type: 'job'},
    "guillotine1": { label : "Guillotine", type: 'job'},
    "duplo1": { label : "Duplo", type: 'job'},
    "graphicwizard1": { label : "Graphic Wizard", type: 'job'},
    "tagholepuncher1": { label  : "Tag Hole Puncher", type: 'job'},
    "Laser": { label  : "Laser", type: 'job'}
};



export const STATION_LABELS = [
    "Bin Station",
    "QA Station",
    "Shipment Station",
    "UPS Station",
    "Horizon 1", 
    "Horizon 2",
    "Guillotine",
    "Duplo",
    "Graphic Wizard",
    "Tag Hole Puncher",
    "Laser"
]

export const HORIZONCOLORMAPS = {
    '1': { bg: 'bg-success', hvr: 'hvr-fade-success', name: "Horizon 1" },
    '2': { bg: 'bg-info', hvr: 'hvr-fade-info', name: "Horizon 2" },
    '3': { bg: 'bg-autumn', hvr: 'hvr-fade-autumn', name: "Horizon 3" },
    '4': { bg: 'bg-midnight', hvr: 'hvr-fade-midnight', name: "Laser" },
    '5': { bg: 'bg-chestnut', hvr: 'hvr-fade-chestnut', name: "Horizon 4" },
    '6': { bg: 'bg-yellow', hvr: 'hvr-fade-yellow', name: "Horizon 5" },
    '7': { bg: 'bg-pink', hvr: 'hvr-fade-pink', name: "Horizon 6" },
    '8': { bg: 'bg-purple', hvr: 'hvr-fade-purple', name: "Horizon 7" },
    '9': { bg: 'bg-light-cyan', hvr: 'hvr-fade-light-cyan', name: "Horizon 8" },
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/job-locations.ts